import { PaymentApi } from "services/api/payment";

export const getPaymentURL = async () => {
  const paymentApi = new PaymentApi();
  const payload = await paymentApi.getPaymentTokenPayload();
  if (!payload) return null;
  const url = paymentApi.getPaymentUrl(payload.token);
  return url;
};
